import React, { useState } from 'react';
import { Calendar, Tag } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { newsArticles } from '@/mockData';

const News = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  const categories = ['All', 'Campaign Updates', 'Press Releases', 'Community Events'];

  const filteredArticles = selectedCategory === 'All' 
    ? newsArticles 
    : newsArticles.filter(article => article.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-navy-900 to-navy-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold mb-4">Campaign News</h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Stay updated on our campaign progress and community events
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <Button
                key={category}
                onClick={() => setSelectedCategory(category)}
                variant={selectedCategory === category ? 'default' : 'outline'}
                className={selectedCategory === category 
                  ? 'bg-red-600 hover:bg-red-700 text-white' 
                  : 'border-navy-900 text-navy-900 hover:bg-navy-900 hover:text-white'}
              >
                {category}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* News Articles */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.map((article) => (
              <Card key={article.id} className="overflow-hidden hover:shadow-xl transition-shadow bg-white">
                <div className="w-full h-56 overflow-hidden bg-white">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <CardContent className="p-6 bg-white">
                  <div className="flex items-center space-x-4 text-sm text-gray-500 mb-3">
                    <div className="flex items-center space-x-1">
                      <Calendar className="w-4 h-4" />
                      <span>{article.date}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Tag className="w-4 h-4" />
                      <span className="text-red-600 font-semibold">{article.category}</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-navy-900 mb-3">{article.title}</h3>
                  <p className="text-gray-600 mb-4">{article.excerpt}</p>
                  <Button 
                    variant="outline" 
                    className="border-navy-900 text-navy-900 hover:bg-navy-900 hover:text-white w-full"
                  >
                    Read More
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-600 text-lg">No articles found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-16 bg-navy-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">Stay Informed</h2>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
            Get the latest campaign updates delivered directly to your inbox
          </p>
          <Button 
            size="lg" 
            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8"
            onClick={() => window.location.href = '/#signup-form'}
          >
            Sign Up for Updates
          </Button>
        </div>
      </section>
    </div>
  );
};

export default News;
